import { render, staticRenderFns } from "./Tertiary.vue?vue&type=template&id=6c42e1aa&scoped=true"
import script from "./Tertiary.vue?vue&type=script&lang=js"
export * from "./Tertiary.vue?vue&type=script&lang=js"
import style0 from "./Tertiary.vue?vue&type=style&index=0&id=6c42e1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42e1aa",
  null
  
)

export default component.exports